import { useEffect } from 'react';

let locks = 0;
let previousOverflow = '';

/**
 * Stops the page scrolling behind an overlay while `active`. Counted, so a
 * modal closing over a drawer that is still open leaves the page locked:
 * each overlay used to reset `body.style.overflow` itself on close, which
 * unlocked the page under the drawer.
 */
export function useBodyScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;
    if (locks === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    locks += 1;
    return () => {
      locks -= 1;
      if (locks === 0) document.body.style.overflow = previousOverflow;
    };
  }, [active]);
}
